import {Routes} from '@angular/router'
import {adminAuthGuard, LoginComponent} from '@sparbanken-syd/sparbanken-syd-bankid'

import {ADMIN_ROUTE_PATH, DEPLOY_ROUTE_PATH, HOME_ROUTE_PATH, LOGIN_ROUTE_PATH} from './application/data-types'
import {roleResolver} from './application/role.resolver'
import {siteResolver} from './application/site.resolver'
import {userResolver} from './application/user.resolver'

export const routes: Routes = [
  {
    path: HOME_ROUTE_PATH,
    loadComponent: () => import('./home/home/home.component').then(m => m.HomeComponent),
    canActivate: [adminAuthGuard],
    resolve: {
      sites: siteResolver,
      roles: roleResolver
    }
  },
  {
    path: DEPLOY_ROUTE_PATH,
    loadChildren: () => import('./deploy/deploy-routes'),
    canActivate: [adminAuthGuard]
  },
  {
    path: ADMIN_ROUTE_PATH,
    loadComponent: () => import('./admin/home/home.component').then(m => m.HomeComponent),
    canActivate: [adminAuthGuard],
    resolve: {
      users: userResolver,
      roles: roleResolver,
      sites: siteResolver
    }
  },
  {
    path: LOGIN_ROUTE_PATH,
    component: LoginComponent
  },
  {
    path: 'opening-hours',
    loadChildren: () => import('./opening-hours/routes'),
    canActivate: [adminAuthGuard]

  },
  {
    path: 'service-catalog',
    loadChildren: () => import('./service-catalog/routes'),
    canActivate: [adminAuthGuard]

  },
  {
    path: 'bolagsverket',
    loadChildren: () => import('./bolagsverket/routes'),
    canActivate: [adminAuthGuard]
  },
  {
    path: 'authenticated',
    loadComponent: () => import('./gitlab/authenticated/authenticated').then(c => c.Authenticated)
  },
  {
    path: '**',
    redirectTo: LOGIN_ROUTE_PATH
  }
]